import React from 'react';

import FeatureGates from '@atlaskit/feature-gate-js-client';
import { fg } from '@atlaskit/platform-feature-flags';
import UFOCustomData from '@atlaskit/react-ufo/custom-data';

export const getIsInJiraHoldoutData = () => {
	// This explicitly does not fire exposure, in order to prevent a Holdout exposure, which can dilute the Holdout measurement.
	const isInJiraHoldout =
		FeatureGates.initializeCompleted() &&
		!FeatureGates.checkGate('product-jira-tenant_id-fy26h1-tenant-user-gate', {
			fireGateExposure: false,
		});

	return {
		holdout: isInJiraHoldout ? 'jira-holdout' : '',
	};
};

export const JiraHoldoutCustomData = () => {
	if (fg('add_holdout_custom_data')) {
		return <UFOCustomData data={getIsInJiraHoldoutData()} />;
	}
	return null;
};
